import React from 'react'

export default function ArchiveIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.53255 10.3333H19.5326V18.67C19.5326 19.1283 19.1617 19.5 18.7051 19.5H5.36005C5.2512 19.4999 5.14344 19.4783 5.04293 19.4365C4.94242 19.3948 4.85113 19.3336 4.77428 19.2565C4.69743 19.1794 4.63652 19.0879 4.59505 18.9873C4.55357 18.8867 4.53233 18.7788 4.53255 18.67V10.3333ZM9.53255 12V13.6667H14.5326V12H9.53255ZM3.69922 5.33333C3.69922 4.87333 4.07839 4.5 4.52589 4.5H19.5392C19.9959 4.5 20.3659 4.87 20.3659 5.33333V8.66667H3.69922V5.33333Z" fill="currentColor"/>
        </svg>
    )
}
